// Previous menu locations remain searchable while operators learn the new layout.
const LEGACY_MENU_PATHS = {
  'blacklist-customer': 'Monitoring / Blacklist Idpel',
  'blacklist-ip': 'Monitoring / Blacklist IP',
  'monitoring-otp': 'Monitoring / OTP',
  'monitoring-customer-limit': 'Monitoring / Limit',
  'monitoring-customer-history-pin': 'Monitoring / Riwayat Customer / Ganti Pin',
  'monitoring-customer-wrong-pin': 'Monitoring / Riwayat Customer / Salah Pin',
  customers: 'Members / Customers',
  'setting-spv': 'Members / SPV',
  partners: 'Members / Partner',
  'verification-customer': 'Pengajuan / Verifikasi Customer',
  'request-limit': 'Pengajuan / Pengajuan Limit',
  'deposit-method': 'E-Wallet / Metode / Pembayaran Deposit',
  'payment-method-ppob': 'E-Wallet / Metode / Pembayaran PPOB',
  'payment-method-webtopup': 'E-Wallet / Metode / Pembayaran WebTopup',
  'setting-bank-deposit': 'E-Wallet / Pengaturan / Bank',
  'ppob-product-category': 'PPOB / Produk / Kategori',
  'ppob-product': 'PPOB / Produk / Produk',
  'ppob-product-vendor': 'PPOB / Produk / Produk Vendor',
  'product-inject-category': 'PPOB / Product Inject / Kategori',
  'ppob-inject-label': 'PPOB / Product Inject / Label',
  'product-inject-whitelist-sn': 'PPOB / Product Inject / Whitelist SN',
  'product-voucher-category': 'PPOB / Product Voucher / Kategori',
  'ppob-voucher-label': 'PPOB / Product Voucher / Label',
  'product-voucher-product': 'PPOB / Product Voucher / Produk',
  'product-voucher-list-voucher': 'PPOB / Product Voucher / Stok',
  'limit-bypass-emoney': 'PPOB / Pengaturan / Limit Bypass E-money',
  'emoney-margin': 'PPOB / Pengaturan / E-money',
  'ppob-transaction': 'PPOB TRX / Transaksi',
  'report-transaction-inbox': 'PPOB TRX / Inbox',
  'product-inject-inbox': 'PPOB TRX / Inbox Inject',
  'report-innet-trx': 'PPOB TRX / Innet Trx',
  'report-transfer-uang': 'PPOB TRX / Transfer Uang',
  'report-transfer-saldo': 'PPOB TRX / Transfer Saldo',
  'content-blog': 'Konten / Blog / Blog',
  'content-category': 'Konten / Blog / Kategori',
  'content-slider': 'Konten / Slider / Web',
  'content-slider-app': 'Konten / Slider / App',
  'static-content': 'Konten / Content Statis',
  'report-customer-deposit-saldo': 'Reports / Customer / Saldo',
  'report-deposit': 'Reports / Customer / Deposit',
  'report-mutasi-saldo': 'Reports / Customer / Mutasi Saldo',
  'report-registrasi-customer': 'Reports / Customer / Registrasi',
  'report-customer-fraud': 'Reports / Customer / Fraud',
  'report-customer-markup-company': 'Reports / Customer / Markup Company',
  'report-customer-markup': 'Reports / Customer / Markup Personal',
  'report-customer-program': 'Reports / Customer / Program',
  'report-customer-qris': 'Reports / Customer / Qris',
  'report-idpel-emoney': 'Reports / Transaksi / Idpel Emoney',
  'report-group-tfsaldo': 'Reports / Transaksi / Idpel Tranfer Saldo',
  'report-idpel-tfbank': 'Reports / Transaksi / Idpel Transfer Bank',
  'report-ppob-pending-time': 'Reports / Transaksi / Pending Time',
  'report-ppob-transaction': 'Reports / Transaksi / Transaction',
  'report-webtopup-transaction': 'Reports / Transaksi / Web Topup Transaction',
  'report-app-transaction': 'Reports / Transaksi / App Transaction',
  'report-customer-omset': 'Reports / Omset / Customer',
  'report-omset-product': 'Reports / Omset / Produk',
  'report-komisi-spv': 'Reports / Komisi / Komisi SPV',
  'report-ppob-sale': 'Reports / Penjualan Master',
  'report-performa-outlet': 'Reports / Performa Outlet',
  'report-customer-emoney': 'Reports / Top Customer Category',
  'report-laba-rugi-ppob': 'Reports / Laba/Rugi PPOB',
  'report-input-voucher-admin': 'Reports / Input Voucher Admin',
  'export-tagihan': 'Reports / Tagihan PIC',
  'mutasi-bank': 'Reports / Mutasi Bank Deposit',
  'setting-general': 'Pengaturan / General',
  'user-permissions': 'Pengaturan / User Permissions',
  'setting-block-limit': 'Pengaturan / Batasan Blokir',
  'setting-rekomendasi-limit': 'Pengaturan / Rekomendasi Limit',
};

const normalizeSearch = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

export const getSearchableMenus = (groups, hasAccess) => {
  const results = [];
  const seen = new Set();

  const collect = (items, parentLabels) => {
    for (const item of items || []) {
      const labels = [...parentLabels, item.label];

      if (item.to && !seen.has(item.to) && hasAccess(item.id, item.to)) {
        seen.add(item.to);
        const searchText = normalizeSearch([...labels, LEGACY_MENU_PATHS[item.id] || ''].join(' '));

        results.push({ ...item, location: labels.join(' / '), searchText });
      }

      collect(item.subs, labels);
    }
  };

  for (const group of groups || []) collect(group.items, [group.title]);

  return results;
};

export const searchMenus = (items, query) => {
  const words = normalizeSearch(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return [];

  return items.filter((item) => words.every((word) => item.searchText.includes(word)));
};
